// roles
export const PERM_ROLES_MANAGE = 'manageRoles';

// users
export const PERM_USERS_PAGE_VIEW = 'usersPage';
export const PERM_USERS_ADD_NEW = 'addUsers';
export const PERM_USERS_UPDATE = 'updateUsers';
export const PERM_USERS_DELETE = 'deleteUsers';

// stores
export const PERM_STORES_PAGE_VIEW = 'viewAllStores';
export const PERM_STORES_ADD_NEW = 'createStores';
export const PERM_STORES_EDIT = 'editStores';
export const PERM_STORES_ASSIGN = 'assignStores';
export const PERM_STORES_DELETE = 'deleteStores';

// setting pages
export const PERM_STORE_MANAGE_BUDGET = 'manageBudget';
export const PERM_STORE_SETTINGS = 'storeSettings';
export const PERM_STORE_LICENSE = 'storeLicense';

// growz pages
export const PERM_GROWZ_PRODUCT_VIEW = 'products';
export const PERM_GROWZ_ANALYTICS_VIEW = 'analytics';
export const PERM_GROWZ_ALL_CAMPAIGNS_VIEW = 'campaigns';
export const PERM_GROWZ_MICROGOALS_VIEW = 'microgoalsView';
export const PERM_GROWZ_ANALYZE_SCREEN_ACCESS = 'analyzeScreenAccess';
export const PERM_GROWZ_KEYWORD_TOOL_ACCESS = 'keywordAccessTool';
export const PERM_GROWZ_RANK_TRACKER_TOOL_ACCESS = 'rankTrackerTool';
export const PERM_GROWZ_SUBSCRIPTIONS = 'growzSubscriptions';

export const PERM_MICROGOALS_LAUNCH = 'microgoalsLaunch';
export const PERM_MONITOR_ACTIVITY_VIEW = 'monitorActivityView';
export const PERM_MONITOR_ACTIVITY_PAUSE = 'monitorActivityPause';
export const PERM_MONITOR_ACTIVITY_DELETE = 'monitorActivityDelete';
export const PERM_CAMPAIGN_BID_UPDATE = 'campaignBidUpdate';
export const PERM_CAMPAIGN_BID_CONFIGURATION = 'campaignBidConfiguration';
export const PERM_CAMPAIGN_ANALYZE_SCREEN = 'campaignAnalyzeScreen';
export const PERM_CAMPAIGN_AUTOPILOT_SCREEN = 'campaignAutopilot';

// aisle
export const PERM_AISLE_LAUNCH = 'launchAislePermission';
export const PERM_AISLE_ACTIVE_LIST = 'aisleActiveList';
export const PERM_AISLE_PAUSE_PERMISSION = 'pauseAislePermission';
export const PERM_AISLE_DELETE_PERMISSION = 'deleteAislePermission';
export const PERM_AISLE_ACTIVITY_PERMISSION = 'aisleActivityPermission';
export const PERM_AISLE_STATS_PERMISSION = 'aisleStatsPermission';
export const PERM_AISLE_SUBSCRIPTION = 'aisleSubscription';
